export const DOMAIN =
  process.env.NODE_ENV === "development" ? "https://json.edhrec.com/pages" : "https://json.edhrec.com/pages";
